const industryData = [
    {
      "label": "农、林、牧、渔业",
      "value": "农、林、牧、渔业",
      "children": [
        {
          "label": "农业",
          "value": "农业",
          "children": [
            {
              "label": "谷物种植",
              "value": "谷物种植"
            },
            {
              "label": "豆类、油料和薯类种植",
              "value": "豆类、油料和薯类种植"
            },
            {
              "label": "棉、麻、糖、烟草种植",
              "value": "棉、麻、糖、烟草种植"
            },
            {
              "label": "蔬菜、食用菌及园艺作物种植",
              "value": "蔬菜、食用菌及园艺作物种植"
            },
            {
              "label": "水果种植",
              "value": "水果种植"
            },
            {
              "label": "坚果、含油果、香料和饮料作物种植",
              "value": "坚果、含油果、香料和饮料作物种植"
            },
            {
              "label": "中药材种植",
              "value": "中药材种植"
            },
            {
              "label": "草种植及割草",
              "value": "草种植及割草"
            },
            {
              "label": "其他农业",
              "value": "其他农业"
            }
          ]
        },
        {
          "label": "林业",
          "value": "林业",
          "children": [
            {
              "label": "林木育种和育苗",
              "value": "林木育种和育苗"
            },
            {
              "label": "造林和更新",
              "value": "造林和更新"
            },
            {
              "label": "森林经营、管护和改培",
              "value": "森林经营、管护和改培"
            },
            {
              "label": "木材和竹材采运",
              "value": "木材和竹材采运"
            },
            {
              "label": "林产品采集",
              "value": "林产品采集"
            }
          ]
        },
        {
          "label": "畜牧业",
          "value": "畜牧业",
          "children": [
            {
              "label": "牲畜饲养",
              "value": "牲畜饲养"
            },
            {
              "label": "家禽饲养",
              "value": "家禽饲养"
            },
            {
              "label": "狩猎和捕捉动物",
              "value": "狩猎和捕捉动物"
            },
            {
              "label": "其他畜牧业",
              "value": "其他畜牧业"
            }
          ]
        },
        {
          "label": "渔业",
          "value": "渔业",
          "children": [
            {
              "label": "水产养殖",
              "value": "水产养殖"
            },
            {
              "label": "水产捕捞",
              "value": "水产捕捞"
            }
          ]
        },
        {
          "label": "农、林、牧、渔专业及辅助性活动",
          "value": "农、林、牧、渔专业及辅助性活动",
          "children": [
            {
              "label": "农业专业及辅助性活动",
              "value": "农业专业及辅助性活动"
            },
            {
              "label": "林业专业及辅助性活动",
              "value": "林业专业及辅助性活动"
            },
            {
              "label": "畜牧专业及辅助性活动",
              "value": "畜牧专业及辅助性活动"
            },
            {
              "label": "渔业专业及辅助性活动",
              "value": "渔业专业及辅助性活动"
            }
          ]
        }
      ]
    },
    {
      "label": "采矿业",
      "value": "采矿业",
      "children": [
        {
          "label": "煤炭开采和洗选业",
          "value": "煤炭开采和洗选业",
          "children": [
            {
              "label": "烟煤和无烟煤开采洗选",
              "value": "烟煤和无烟煤开采洗选"
            },
            {
              "label": "褐煤开采洗选",
              "value": "褐煤开采洗选"
            },
            {
              "label": "其他煤炭采选",
              "value": "其他煤炭采选"
            }
          ]
        },
        {
          "label": "石油和天然气开采业",
          "value": "石油和天然气开采业",
          "children": [
            {
              "label": "石油开采",
              "value": "石油开采"
            },
            {
              "label": "天然气开采",
              "value": "天然气开采"
            }
          ]
        },
        {
          "label": "黑色金属矿采选业",
          "value": "黑色金属矿采选业",
          "children": [
            {
              "label": "铁矿采选",
              "value": "铁矿采选"
            },
            {
              "label": "锰矿、铬矿采选",
              "value": "锰矿、铬矿采选"
            },
            {
              "label": "其他黑色金属矿采选",
              "value": "其他黑色金属矿采选"
            }
          ]
        },
        {
          "label": "有色金属矿采选业",
          "value": "有色金属矿采选业",
          "children": [
            {
              "label": "常用有色金属矿采选",
              "value": "常用有色金属矿采选"
            },
            {
              "label": "贵金属矿采选",
              "value": "贵金属矿采选"
            },
            {
              "label": "稀有稀土金属矿采选",
              "value": "稀有稀土金属矿采选"
            }
          ]
        },
        {
          "label": "非金属矿采选业",
          "value": "非金属矿采选业",
          "children": [
            {
              "label": "土砂石开采",
              "value": "土砂石开采"
            },
            {
              "label": "化学矿开采",
              "value": "化学矿开采"
            },
            {
              "label": "采盐",
              "value": "采盐"
            },
            {
              "label": "石棉及其他非金属矿采选",
              "value": "石棉及其他非金属矿采选"
            }
          ]
        },
        {
          "label": "开采专业及辅助性活动",
          "value": "开采专业及辅助性活动",
          "children": [
            {
              "label": "煤炭开采和洗选专业及辅助性活动",
              "value": "煤炭开采和洗选专业及辅助性活动"
            },
            {
              "label": "石油和天然气开采专业及辅助性活动",
              "value": "石油和天然气开采专业及辅助性活动"
            },
            {
              "label": "其他开采专业及辅助性活动",
              "value": "其他开采专业及辅助性活动"
            }
          ]
        },
        {
          "label": "其他采矿业",
          "value": "其他采矿业",
          "children": [
            {
              "label": "其他采矿业",
              "value": "其他采矿业"
            }
          ]
        }
      ]
    },
    {
      "label": "制造业",
      "value": "制造业",
      "children": [
        {
          "label": "农副食品加工业",
          "value": "农副食品加工业",
          "children": [
            {
              "label": "谷物磨制",
              "value": "谷物磨制"
            },
            {
              "label": "饲料加工",
              "value": "饲料加工"
            },
            {
              "label": "植物油加工",
              "value": "植物油加工"
            },
            {
              "label": "制糖业",
              "value": "制糖业"
            },
            {
              "label": "屠宰及肉类加工",
              "value": "屠宰及肉类加工"
            },
            {
              "label": "水产品加工",
              "value": "水产品加工"
            },
            {
              "label": "蔬菜、菌类、水果和坚果加工",
              "value": "蔬菜、菌类、水果和坚果加工"
            },
            {
              "label": "其他农副食品加工",
              "value": "其他农副食品加工"
            }
          ]
        },
        {
          "label": "食品制造业",
          "value": "食品制造业",
          "children": [
            {
              "label": "焙烤食品制造",
              "value": "焙烤食品制造"
            },
            {
              "label": "糖果、巧克力及蜜饯制造",
              "value": "糖果、巧克力及蜜饯制造"
            },
            {
              "label": "方便食品制造",
              "value": "方便食品制造"
            },
            {
              "label": "乳制品制造",
              "value": "乳制品制造"
            },
            {
              "label": "罐头食品制造",
              "value": "罐头食品制造"
            },
            {
              "label": "调味品、发酵制品制造",
              "value": "调味品、发酵制品制造"
            },
            {
              "label": "他食品制造",
              "value": "他食品制造"
            }
          ]
        },
        {
          "label": "酒、饮料和精制茶制造业",
          "value": "酒、饮料和精制茶制造业",
          "children": [
            {
              "label": "酒的制造",
              "value": "酒的制造"
            },
            {
              "label": "饮料制造",
              "value": "饮料制造"
            },
            {
              "label": "精制茶加工",
              "value": "精制茶加工"
            }
          ]
        },
        {
          "label": "烟草制品业",
          "value": "烟草制品业",
          "children": [
            {
              "label": "烟叶复烤",
              "value": "烟叶复烤"
            },
            {
              "label": "卷烟制造",
              "value": "卷烟制造"
            },
            {
              "label": "其他烟草制品制造",
              "value": "其他烟草制品制造"
            }
          ]
        },
        {
          "label": "纺织业",
          "value": "纺织业",
          "children": [
            {
              "label": "棉纺织及印染精加工",
              "value": "棉纺织及印染精加工"
            },
            {
              "label": "毛纺织及染整精加工",
              "value": "毛纺织及染整精加工"
            },
            {
              "label": "麻纺织及染整精加工",
              "value": "麻纺织及染整精加工"
            },
            {
              "label": "丝绢纺织及印染精加工",
              "value": "丝绢纺织及印染精加工"
            },
            {
              "label": "化纤织造及印染精加工",
              "value": "化纤织造及印染精加工"
            },
            {
              "label": "针织或钩针编织物及其制品制造",
              "value": "针织或钩针编织物及其制品制造"
            },
            {
              "label": "家用纺织制成品制造",
              "value": "家用纺织制成品制造"
            },
            {
              "label": "产业用纺织制成品制造",
              "value": "产业用纺织制成品制造"
            }
          ]
        },
        {
          "label": "纺织服装、服饰业",
          "value": "纺织服装、服饰业",
          "children": [
            {
              "label": "机织服装制造",
              "value": "机织服装制造"
            },
            {
              "label": "针织或钩针编织服装制造",
              "value": "针织或钩针编织服装制造"
            },
            {
              "label": "服饰制造",
              "value": "服饰制造"
            }
          ]
        },
        {
          "label": "皮革、毛皮、羽毛及其制品和制鞋业",
          "value": "皮革、毛皮、羽毛及其制品和制鞋业",
          "children": [
            {
              "label": "皮革鞣制加工",
              "value": "皮革鞣制加工"
            },
            {
              "label": "皮革制品制造",
              "value": "皮革制品制造"
            },
            {
              "label": "毛皮鞣制及制品加工",
              "value": "毛皮鞣制及制品加工"
            },
            {
              "label": "羽毛(绒)加工及制品制造",
              "value": "羽毛(绒)加工及制品制造"
            },
            {
              "label": "制鞋业",
              "value": "制鞋业"
            }
          ]
        },
        {
          "label": "木材加工和木、竹、藤、棕、草制品业",
          "value": "木材加工和木、竹、藤、棕、草制品业",
          "children": [
            {
              "label": "木材加工",
              "value": "木材加工"
            },
            {
              "label": "人造板制造",
              "value": "人造板制造"
            },
            {
              "label": "木质制品制造",
              "value": "木质制品制造"
            },
            {
              "label": "竹、藤、棕、草等制品制造",
              "value": "竹、藤、棕、草等制品制造"
            }
          ]
        },
        {
          "label": "家具制造业",
          "value": "家具制造业",
          "children": [
            {
              "label": "木质家具制造",
              "value": "木质家具制造"
            },
            {
              "label": "竹、藤家具制造",
              "value": "竹、藤家具制造"
            },
            {
              "label": "金属家具制造",
              "value": "金属家具制造"
            },
            {
              "label": "塑料家具制造",
              "value": "塑料家具制造"
            },
            {
              "label": "其他家具制造",
              "value": "其他家具制造"
            }
          ]
        },
        {
          "label": "造纸和纸制品业",
          "value": "造纸和纸制品业",
          "children": [
            {
              "label": "纸浆制造",
              "value": "纸浆制造"
            },
            {
              "label": "造纸",
              "value": "造纸"
            },
            {
              "label": "纸制品制造",
              "value": "纸制品制造"
            }
          ]
        },
        {
          "label": "印刷和记录媒介复制业",
          "value": "印刷和记录媒介复制业",
          "children": [
            {
              "label": "印刷",
              "value": "印刷"
            },
            {
              "label": "装订及印刷相关服务",
              "value": "装订及印刷相关服务"
            },
            {
              "label": "记录媒介复制",
              "value": "记录媒介复制"
            }
          ]
        },
        {
          "label": "文教、工美、体育和娱乐用品制造业",
          "value": "文教、工美、体育和娱乐用品制造业",
          "children": [
            {
              "label": "文教办公用品制造",
              "value": "文教办公用品制造"
            },
            {
              "label": "乐器制造",
              "value": "乐器制造"
            },
            {
              "label": "工艺美术及礼仪用品制造",
              "value": "工艺美术及礼仪用品制造"
            },
            {
              "label": "体育用品制造",
              "value": "体育用品制造"
            },
            {
              "label": "玩具制造",
              "value": "玩具制造"
            },
            {
              "label": "游艺器材及娱乐用品制造",
              "value": "游艺器材及娱乐用品制造"
            }
          ]
        },
        {
          "label": "石油、煤炭及其他燃料加工业",
          "value": "石油、煤炭及其他燃料加工业",
          "children": [
            {
              "label": "精炼石油产品制造",
              "value": "精炼石油产品制造"
            },
            {
              "label": "煤炭加工",
              "value": "煤炭加工"
            },
            {
              "label": "核燃料加工",
              "value": "核燃料加工"
            },
            {
              "label": "生物质燃料加工",
              "value": "生物质燃料加工"
            }
          ]
        },
        {
          "label": "化学原料和化学制品制造业",
          "value": "化学原料和化学制品制造业",
          "children": [
            {
              "label": "基础化学原料制造",
              "value": "基础化学原料制造"
            },
            {
              "label": "肥料制造",
              "value": "肥料制造"
            },
            {
              "label": "农药制造",
              "value": "农药制造"
            },
            {
              "label": "涂料、油墨、颜料及类似产品制造",
              "value": "涂料、油墨、颜料及类似产品制造"
            },
            {
              "label": "合成材料制造",
              "value": "合成材料制造"
            },
            {
              "label": "专用化学产品制造",
              "value": "专用化学产品制造"
            },
            {
              "label": "炸药、火工及焰火产品制造",
              "value": "炸药、火工及焰火产品制造"
            },
            {
              "label": "日用化学产品制造",
              "value": "日用化学产品制造"
            }
          ]
        },
        {
          "label": "医药制造业",
          "value": "医药制造业",
          "children": [
            {
              "label": "化学药品原料药制造",
              "value": "化学药品原料药制造"
            },
            {
              "label": "化学药品制剂制造",
              "value": "化学药品制剂制造"
            },
            {
              "label": "中药饮片加工",
              "value": "中药饮片加工"
            },
            {
              "label": "中成药生产",
              "value": "中成药生产"
            },
            {
              "label": "兽用药品制造",
              "value": "兽用药品制造"
            },
            {
              "label": "生物药品制品制造",
              "value": "生物药品制品制造"
            },
            {
              "label": "卫生材料及医药用品制造",
              "value": "卫生材料及医药用品制造"
            },
            {
              "label": "药用辅料及包装材料",
              "value": "药用辅料及包装材料"
            }
          ]
        },
        {
          "label": "化学纤维制造业",
          "value": "化学纤维制造业",
          "children": [
            {
              "label": "纤维素纤维原料及纤维制造",
              "value": "纤维素纤维原料及纤维制造"
            },
            {
              "label": "合成纤维制造",
              "value": "合成纤维制造"
            },
            {
              "label": "生物基材料制造",
              "value": "生物基材料制造"
            }
          ]
        },
        {
          "label": "橡胶和塑料制品业",
          "value": "橡胶和塑料制品业",
          "children": [
            {
              "label": "橡胶制品业",
              "value": "橡胶制品业"
            },
            {
              "label": "塑料制品业",
              "value": "塑料制品业"
            }
          ]
        },
        {
          "label": "非金属矿物制品业",
          "value": "非金属矿物制品业",
          "children": [
            {
              "label": "水泥、石灰和石膏制造",
              "value": "水泥、石灰和石膏制造"
            },
            {
              "label": "石膏、水泥制品及类似制品制造",
              "value": "石膏、水泥制品及类似制品制造"
            },
            {
              "label": "砖瓦、石材等建筑材料制造",
              "value": "砖瓦、石材等建筑材料制造"
            },
            {
              "label": "玻璃制造",
              "value": "玻璃制造"
            },
            {
              "label": "玻璃制品制造",
              "value": "玻璃制品制造"
            },
            {
              "label": "玻璃纤维和玻璃纤维增强塑料制品制造",
              "value": "玻璃纤维和玻璃纤维增强塑料制品制造"
            },
            {
              "label": "陶瓷制品制造",
              "value": "陶瓷制品制造"
            },
            {
              "label": "耐火材料制品制造",
              "value": "耐火材料制品制造"
            },
            {
              "label": "石墨及其他非金属矿物制品制造",
              "value": "石墨及其他非金属矿物制品制造"
            }
          ]
        },
        {
          "label": "黑色金属冶炼和压延加工业",
          "value": "黑色金属冶炼和压延加工业",
          "children": [
            {
              "label": "炼铁",
              "value": "炼铁"
            },
            {
              "label": "炼钢",
              "value": "炼钢"
            },
            {
              "label": "钢压延加工",
              "value": "钢压延加工"
            },
            {
              "label": "铁合金冶炼",
              "value": "铁合金冶炼"
            }
          ]
        },
        {
          "label": "有色金属冶炼和压延加工业",
          "value": "有色金属冶炼和压延加工业",
          "children": [
            {
              "label": "常用有色金属冶炼",
              "value": "常用有色金属冶炼"
            },
            {
              "label": "贵金属冶炼",
              "value": "贵金属冶炼"
            },
            {
              "label": "稀有稀土金属冶炼",
              "value": "稀有稀土金属冶炼"
            },
            {
              "label": "有色金属合金制造",
              "value": "有色金属合金制造"
            },
            {
              "label": "有色金属压延加工",
              "value": "有色金属压延加工"
            }
          ]
        },
        {
          "label": "金属制品业",
          "value": "金属制品业",
          "children": [
            {
              "label": "结构性金属制品制造",
              "value": "结构性金属制品制造"
            },
            {
              "label": "金属工具制造",
              "value": "金属工具制造"
            },
            {
              "label": "集装箱及金属包装容器制造",
              "value": "集装箱及金属包装容器制造"
            },
            {
              "label": "金属丝绳及其制品制造",
              "value": "金属丝绳及其制品制造"
            },
            {
              "label": "建筑、安全用金属制品制造",
              "value": "建筑、安全用金属制品制造"
            },
            {
              "label": "金属表面处理及热处理加工",
              "value": "金属表面处理及热处理加工"
            },
            {
              "label": "搪瓷制品制造",
              "value": "搪瓷制品制造"
            },
            {
              "label": "金属制日用品制造",
              "value": "金属制日用品制造"
            },
            {
              "label": "铸造及其他金属制品制造",
              "value": "铸造及其他金属制品制造"
            }
          ]
        },
        {
          "label": "通用设备制造业",
          "value": "通用设备制造业",
          "children": [
            {
              "label": "锅炉及原动设备制造",
              "value": "锅炉及原动设备制造"
            },
            {
              "label": "金属加工机械制造",
              "value": "金属加工机械制造"
            },
            {
              "label": "物料搬运设备制造",
              "value": "物料搬运设备制造"
            },
            {
              "label": "泵、阀门、压缩机及类似机械制造",
              "value": "泵、阀门、压缩机及类似机械制造"
            },
            {
              "label": "轴承、齿轮和传动部件制造",
              "value": "轴承、齿轮和传动部件制造"
            },
            {
              "label": "烘炉、风机、包装等设备制造",
              "value": "烘炉、风机、包装等设备制造"
            },
            {
              "label": "文化、办公用机械制造",
              "value": "文化、办公用机械制造"
            },
            {
              "label": "通用零部件制造",
              "value": "通用零部件制造"
            },
            {
              "label": "其他通用设备制造业",
              "value": "其他通用设备制造业"
            }
          ]
        },
        {
          "label": "专用设备制造业",
          "value": "专用设备制造业",
          "children": [
            {
              "label": "采矿、冶金、建筑专用设备制造",
              "value": "采矿、冶金、建筑专用设备制造"
            },
            {
              "label": "化工、木材、非金属加工专用设备制造",
              "value": "化工、木材、非金属加工专用设备制造"
            },
            {
              "label": "食品、饮料、烟草及饲料生产专用设备制造",
              "value": "食品、饮料、烟草及饲料生产专用设备制造"
            },
            {
              "label": "印刷、制药、日化及日用品生产专用设备制造",
              "value": "印刷、制药、日化及日用品生产专用设备制造"
            },
            {
              "label": "纺织、服装和皮革加工专用设备制造",
              "value": "纺织、服装和皮革加工专用设备制造"
            },
            {
              "label": "电子和电工机械专用设备制造",
              "value": "电子和电工机械专用设备制造"
            },
            {
              "label": "农、林、牧、渔专用机械制造",
              "value": "农、林、牧、渔专用机械制造"
            },
            {
              "label": "医疗仪器设备及器械制造",
              "value": "医疗仪器设备及器械制造"
            },
            {
              "label": "环保、邮政、社会公共服务及其他专用设备制造",
              "value": "环保、邮政、社会公共服务及其他专用设备制造"
            }
          ]
        },
        {
          "label": "汽车制造业",
          "value": "汽车制造业",
          "children": [
            {
              "label": "汽车整车制造",
              "value": "汽车整车制造"
            },
            {
              "label": "汽车用发动机制造",
              "value": "汽车用发动机制造"
            },
            {
              "label": "改装汽车制造",
              "value": "改装汽车制造"
            },
            {
              "label": "低速汽车制造",
              "value": "低速汽车制造"
            },
            {
              "label": "电车制造",
              "value": "电车制造"
            },
            {
              "label": "汽车车身、挂车制造",
              "value": "汽车车身、挂车制造"
            },
            {
              "label": "汽车零部件及配件制造",
              "value": "汽车零部件及配件制造"
            }
          ]
        },
        {
          "label": "铁路、船舶、航空航天和其他运输设备制造业",
          "value": "铁路、船舶、航空航天和其他运输设备制造业",
          "children": [
            {
              "label": "铁路运输设备制造",
              "value": "铁路运输设备制造"
            },
            {
              "label": "城市轨道交通设备制造",
              "value": "城市轨道交通设备制造"
            },
            {
              "label": "船舶及相关装置制造",
              "value": "船舶及相关装置制造"
            },
            {
              "label": "航空、航天器及设备制造",
              "value": "航空、航天器及设备制造"
            },
            {
              "label": "摩托车制造",
              "value": "摩托车制造"
            },
            {
              "label": "自行车和残疾人座车制造",
              "value": "自行车和残疾人座车制造"
            },
            {
              "label": "助动车制造",
              "value": "助动车制造"
            },
            {
              "label": "非公路休闲车及零配件制造",
              "value": "非公路休闲车及零配件制造"
            },
            {
              "label": "潜水救捞及其他未列明运输设备制造",
              "value": "潜水救捞及其他未列明运输设备制造"
            }
          ]
        },
        {
          "label": "电气机械和器材制造业",
          "value": "电气机械和器材制造业",
          "children": [
            {
              "label": "电机制造",
              "value": "电机制造"
            },
            {
              "label": "输配电及控制设备制造",
              "value": "输配电及控制设备制造"
            },
            {
              "label": "电线、电缆、光缆及电工器材制造",
              "value": "电线、电缆、光缆及电工器材制造"
            },
            {
              "label": "电池制造",
              "value": "电池制造"
            },
            {
              "label": "家用电力器具制造",
              "value": "家用电力器具制造"
            },
            {
              "label": "非电力家用器具制造",
              "value": "非电力家用器具制造"
            },
            {
              "label": "照明器具制造",
              "value": "照明器具制造"
            },
            {
              "label": "其他电气机械及器材制造",
              "value": "其他电气机械及器材制造"
            }
          ]
        },
        {
          "label": "计算机、通信和其他电子设备制造业",
          "value": "计算机、通信和其他电子设备制造业",
          "children": [
            {
              "label": "计算机制造",
              "value": "计算机制造"
            },
            {
              "label": "通信设备制造",
              "value": "通信设备制造"
            },
            {
              "label": "广播电视设备制造",
              "value": "广播电视设备制造"
            },
            {
              "label": "雷达及配套设备制造",
              "value": "雷达及配套设备制造"
            },
            {
              "label": "非专业视听设备制造",
              "value": "非专业视听设备制造"
            },
            {
              "label": "智能消费设备制造",
              "value": "智能消费设备制造"
            },
            {
              "label": "电子器件制造",
              "value": "电子器件制造"
            },
            {
              "label": "电子元件及电子专用材料制造",
              "value": "电子元件及电子专用材料制造"
            },
            {
              "label": "其他电子设备制造",
              "value": "其他电子设备制造"
            }
          ]
        },
        {
          "label": "仪器仪表制造业",
          "value": "仪器仪表制造业",
          "children": [
            {
              "label": "通用仪器仪表制造",
              "value": "通用仪器仪表制造"
            },
            {
              "label": "专用仪器仪表制造",
              "value": "专用仪器仪表制造"
            },
            {
              "label": "钟表与计时仪器制造",
              "value": "钟表与计时仪器制造"
            },
            {
              "label": "光学仪器制造",
              "value": "光学仪器制造"
            },
            {
              "label": "衡器制造",
              "value": "衡器制造"
            },
            {
              "label": "其他仪器仪表制造业",
              "value": "其他仪器仪表制造业"
            }
          ]
        }
      ]
    },
    {
      "label": "电力、热力、燃气及水生产和供应业",
      "value": "电力、热力、燃气及水生产和供应业",
      "children": [
        {
          "label": "其他制造业",
          "value": "其他制造业",
          "children": [
            {
              "label": "日用杂品制造",
              "value": "日用杂品制造"
            },
            {
              "label": "核辐射加工",
              "value": "核辐射加工"
            },
            {
              "label": "其他未列明制造业",
              "value": "其他未列明制造业"
            }
          ]
        },
        {
          "label": "废弃资源综合利用业",
          "value": "废弃资源综合利用业",
          "children": [
            {
              "label": "金属废料和碎屑加工处理",
              "value": "金属废料和碎屑加工处理"
            },
            {
              "label": "非金属废料和碎屑加工处理",
              "value": "非金属废料和碎屑加工处理"
            }
          ]
        },
        {
          "label": "金属制品、机械和设备修理业",
          "value": "金属制品、机械和设备修理业",
          "children": [
            {
              "label": "金属制品修理",
              "value": "金属制品修理"
            },
            {
              "label": "通用设备修理",
              "value": "通用设备修理"
            },
            {
              "label": "专用设备修理",
              "value": "专用设备修理"
            },
            {
              "label": "铁路、船舶、航空航天等运输设备修理",
              "value": "铁路、船舶、航空航天等运输设备修理"
            },
            {
              "label": "电气设备修理",
              "value": "电气设备修理"
            },
            {
              "label": "仪器仪表修理",
              "value": "仪器仪表修理"
            },
            {
              "label": "其他机械和设备修理业",
              "value": "其他机械和设备修理业"
            }
          ]
        },
        {
          "label": "电力、热力生产和供应业",
          "value": "电力、热力生产和供应业",
          "children": [
            {
              "label": "电力生产",
              "value": "电力生产"
            },
            {
              "label": "电力供应",
              "value": "电力供应"
            },
            {
              "label": "热力生产和供应",
              "value": "热力生产和供应"
            }
          ]
        },
        {
          "label": "燃气生产和供应业",
          "value": "燃气生产和供应业",
          "children": [
            {
              "label": "燃气生产和供应业",
              "value": "燃气生产和供应业"
            },
            {
              "label": "生物质燃气生产和供应业",
              "value": "生物质燃气生产和供应业"
            }
          ]
        },
        {
          "label": "水的生产和供应业",
          "value": "水的生产和供应业",
          "children": [
            {
              "label": "自来水生产和供应",
              "value": "自来水生产和供应"
            },
            {
              "label": "污水处理及其再生利用",
              "value": "污水处理及其再生利用"
            },
            {
              "label": "海水淡化处理",
              "value": "海水淡化处理"
            },
            {
              "label": "其他水的处理、利用与分配",
              "value": "其他水的处理、利用与分配"
            }
          ]
        }
      ]
    },
    {
      "label": "建筑业",
      "value": "建筑业",
      "children": [
        {
          "label": "房屋建筑业",
          "value": "房屋建筑业",
          "children": [
            {
              "label": "住宅房屋建筑",
              "value": "住宅房屋建筑"
            },
            {
              "label": "体育场馆建筑",
              "value": "体育场馆建筑"
            },
            {
              "label": "其他房屋建筑业",
              "value": "其他房屋建筑业"
            }
          ]
        },
        {
          "label": "土木工程建筑业",
          "value": "土木工程建筑业",
          "children": [
            {
              "label": "铁路、道路、隧道和桥梁工程建筑",
              "value": "铁路、道路、隧道和桥梁工程建筑"
            },
            {
              "label": "水利和水运工程建筑",
              "value": "水利和水运工程建筑"
            },
            {
              "label": "海洋工程建筑",
              "value": "海洋工程建筑"
            },
            {
              "label": "工矿工程建筑",
              "value": "工矿工程建筑"
            },
            {
              "label": "架线和管道工程建筑",
              "value": "架线和管道工程建筑"
            },
            {
              "label": "节能环保工程施工",
              "value": "节能环保工程施工"
            },
            {
              "label": "电力工程施工",
              "value": "电力工程施工"
            },
            {
              "label": "其他土木工程建筑",
              "value": "其他土木工程建筑"
            }
          ]
        },
        {
          "label": "建筑安装业",
          "value": "建筑安装业",
          "children": [
            {
              "label": "电气安装",
              "value": "电气安装"
            },
            {
              "label": "管道和设备安装",
              "value": "管道和设备安装"
            },
            {
              "label": "其他建筑安装业",
              "value": "其他建筑安装业"
            }
          ]
        },
        {
          "label": "建筑装饰、装修和其他建筑业",
          "value": "建筑装饰、装修和其他建筑业",
          "children": [
            {
              "label": "建筑装饰和装修业",
              "value": "建筑装饰和装修业"
            },
            {
              "label": "建筑物拆除和场地准备活动",
              "value": "建筑物拆除和场地准备活动"
            },
            {
              "label": "提供施工设备服务",
              "value": "提供施工设备服务"
            },
            {
              "label": "其他未列明建筑业",
              "value": "其他未列明建筑业"
            }
          ]
        }
      ]
    },
    {
      "label": "批发和零售业",
      "value": "批发和零售业",
      "children": [
        {
          "label": "批发业",
          "value": "批发业",
          "children": [
            {
              "label": "农、林、牧、渔产品批发",
              "value": "农、林、牧、渔产品批发"
            },
            {
              "label": "食品、饮料及烟草制品批发",
              "value": "食品、饮料及烟草制品批发"
            },
            {
              "label": "纺织、服装及家庭用品批发",
              "value": "纺织、服装及家庭用品批发"
            },
            {
              "label": "文化、体育用品及器材批发",
              "value": "文化、体育用品及器材批发"
            },
            {
              "label": "医药及医疗器材批发",
              "value": "医药及医疗器材批发"
            },
            {
              "label": "矿产品、建材及化工产品批发",
              "value": "矿产品、建材及化工产品批发"
            },
            {
              "label": "机械设备、五金产品及电子产品批发",
              "value": "机械设备、五金产品及电子产品批发"
            },
            {
              "label": "贸易经纪与代理",
              "value": "贸易经纪与代理"
            },
            {
              "label": "其他批发业",
              "value": "其他批发业"
            }
          ]
        },
        {
          "label": "零售业",
          "value": "零售业",
          "children": [
            {
              "label": "综合零售",
              "value": "综合零售"
            },
            {
              "label": "食品、饮料及烟草制品专门零售",
              "value": "食品、饮料及烟草制品专门零售"
            },
            {
              "label": "纺织、服装及日用品专门零售",
              "value": "纺织、服装及日用品专门零售"
            },
            {
              "label": "文化、体育用品及器材专门零售",
              "value": "文化、体育用品及器材专门零售"
            },
            {
              "label": "医药及医疗器材专门零售",
              "value": "医药及医疗器材专门零售"
            },
            {
              "label": "汽车、摩托车、零配件和燃料及其他动力销售",
              "value": "汽车、摩托车、零配件和燃料及其他动力销售"
            },
            {
              "label": "家用电器及电子产品专门零售",
              "value": "家用电器及电子产品专门零售"
            },
            {
              "label": "五金、家具及室内装饰材料专门零售",
              "value": "五金、家具及室内装饰材料专门零售"
            },
            {
              "label": "货摊、无店铺及其他零售业",
              "value": "货摊、无店铺及其他零售业"
            }
          ]
        }
      ]
    },
    {
      "label": "交通运输、仓储和邮政业",
      "value": "交通运输、仓储和邮政业",
      "children": [
        {
          "label": "铁路运输业",
          "value": "铁路运输业",
          "children": [
            {
              "label": "铁路旅客运输",
              "value": "铁路旅客运输"
            },
            {
              "label": "铁路货物运输",
              "value": "铁路货物运输"
            },
            {
              "label": "铁路运输辅助活动",
              "value": "铁路运输辅助活动"
            }
          ]
        },
        {
          "label": "道路运输业",
          "value": "道路运输业",
          "children": [
            {
              "label": "城市公共交通运输",
              "value": "城市公共交通运输"
            },
            {
              "label": "公路旅客运输",
              "value": "公路旅客运输"
            },
            {
              "label": "道路货物运输",
              "value": "道路货物运输"
            },
            {
              "label": "道路运输辅助活动",
              "value": "道路运输辅助活动"
            }
          ]
        },
        {
          "label": "水上运输业",
          "value": "水上运输业",
          "children": [
            {
              "label": "水上旅客运输",
              "value": "水上旅客运输"
            },
            {
              "label": "水上货物运输",
              "value": "水上货物运输"
            },
            {
              "label": "水上运输辅助活动",
              "value": "水上运输辅助活动"
            }
          ]
        },
        {
          "label": "航空运输业",
          "value": "航空运输业",
          "children": [
            {
              "label": "航空客货运输",
              "value": "航空客货运输"
            },
            {
              "label": "通用航空服务",
              "value": "通用航空服务"
            },
            {
              "label": "航空运输辅助活动",
              "value": "航空运输辅助活动"
            }
          ]
        },
        {
          "label": "管道运输业",
          "value": "管道运输业",
          "children": [
            {
              "label": "海底管道运输",
              "value": "海底管道运输"
            },
            {
              "label": "陆地管道运输",
              "value": "陆地管道运输"
            }
          ]
        },
        {
          "label": "多式联运和运输代理业",
          "value": "多式联运和运输代理业",
          "children": [
            {
              "label": "多式联运",
              "value": "多式联运"
            },
            {
              "label": "运输代理业",
              "value": "运输代理业"
            }
          ]
        },
        {
          "label": "装卸搬运和仓储业",
          "value": "装卸搬运和仓储业",
          "children": [
            {
              "label": "装卸搬运",
              "value": "装卸搬运"
            },
            {
              "label": "通用仓储",
              "value": "通用仓储"
            },
            {
              "label": "低温仓储",
              "value": "低温仓储"
            },
            {
              "label": "危险品仓储",
              "value": "危险品仓储"
            },
            {
              "label": "谷物、棉花等农产品仓储",
              "value": "谷物、棉花等农产品仓储"
            },
            {
              "label": "中药材仓储",
              "value": "中药材仓储"
            },
            {
              "label": "其他仓储业",
              "value": "其他仓储业"
            }
          ]
        },
        {
          "label": "邮政业",
          "value": "邮政业",
          "children": [
            {
              "label": "邮政基本服务",
              "value": "邮政基本服务"
            },
            {
              "label": "快递服务",
              "value": "快递服务"
            },
            {
              "label": "其他寄递服务",
              "value": "其他寄递服务"
            }
          ]
        }
      ]
    },
    {
      "label": "住宿和餐饮业",
      "value": "住宿和餐饮业",
      "children": [
        {
          "label": "住宿业",
          "value": "住宿业",
          "children": [
            {
              "label": "旅游饭店",
              "value": "旅游饭店"
            },
            {
              "label": "一般旅馆",
              "value": "一般旅馆"
            },
            {
              "label": "民宿服务",
              "value": "民宿服务"
            },
            {
              "label": "露营地服务",
              "value": "露营地服务"
            },
            {
              "label": "其他住宿业",
              "value": "其他住宿业"
            }
          ]
        },
        {
          "label": "餐饮业",
          "value": "餐饮业",
          "children": [
            {
              "label": "正餐服务",
              "value": "正餐服务"
            },
            {
              "label": "快餐服务",
              "value": "快餐服务"
            },
            {
              "label": "饮料及冷饮服务",
              "value": "饮料及冷饮服务"
            },
            {
              "label": "餐饮配送及外卖送餐服务",
              "value": "餐饮配送及外卖送餐服务"
            },
            {
              "label": "其他餐饮业",
              "value": "其他餐饮业"
            }
          ]
        }
      ]
    },
    {
      "label": "信息传输、软件和信息技术服务业",
      "value": "信息传输、软件和信息技术服务业",
      "children": [
        {
          "label": "电信、广播电视和卫星传输服务",
          "value": "电信、广播电视和卫星传输服务",
          "children": [
            {
              "label": "电信",
              "value": "电信"
            },
            {
              "label": "广播电视传输服务",
              "value": "广播电视传输服务"
            },
            {
              "label": "卫星传输服务",
              "value": "卫星传输服务"
            }
          ]
        },
        {
          "label": "互联网和相关服务",
          "value": "互联网和相关服务",
          "children": [
            {
              "label": "互联网接入及相关服务",
              "value": "互联网接入及相关服务"
            },
            {
              "label": "互联网信息服务",
              "value": "互联网信息服务"
            },
            {
              "label": "互联网平台",
              "value": "互联网平台"
            },
            {
              "label": "互联网安全服务",
              "value": "互联网安全服务"
            },
            {
              "label": "互联网数据服务",
              "value": "互联网数据服务"
            },
            {
              "label": "其他互联网服务",
              "value": "其他互联网服务"
            }
          ]
        },
        {
          "label": "软件和信息技术服务业",
          "value": "软件和信息技术服务业",
          "children": [
            {
              "label": "软件开发",
              "value": "软件开发"
            },
            {
              "label": "集成电路设计",
              "value": "集成电路设计"
            },
            {
              "label": "信息系统集成和物联网技术服务",
              "value": "信息系统集成和物联网技术服务"
            },
            {
              "label": "运行维护服务",
              "value": "运行维护服务"
            },
            {
              "label": "信息处理和存储支持服务",
              "value": "信息处理和存储支持服务"
            },
            {
              "label": "信息技术咨询服务",
              "value": "信息技术咨询服务"
            },
            {
              "label": "数字内容服务",
              "value": "数字内容服务"
            },
            {
              "label": "其他信息技术服务业",
              "value": "其他信息技术服务业"
            }
          ]
        }
      ]
    },
    {
      "label": "金融业",
      "value": "金融业",
      "children": [
        {
          "label": "货币金融服务",
          "value": "货币金融服务",
          "children": [
            {
              "label": "中央银行服务",
              "value": "中央银行服务"
            },
            {
              "label": "货币银行服务",
              "value": "货币银行服务"
            },
            {
              "label": "非货币银行服务",
              "value": "非货币银行服务"
            },
            {
              "label": "银行理财服务",
              "value": "银行理财服务"
            },
            {
              "label": "银行监管服务",
              "value": "银行监管服务"
            }
          ]
        },
        {
          "label": "资本市场服务",
          "value": "资本市场服务",
          "children": [
            {
              "label": "证券市场服务",
              "value": "证券市场服务"
            },
            {
              "label": "公开募集证券投资基金",
              "value": "公开募集证券投资基金"
            },
            {
              "label": "非公开募集证券投资基金",
              "value": "非公开募集证券投资基金"
            },
            {
              "label": "期货市场服务",
              "value": "期货市场服务"
            },
            {
              "label": "证券期货监管服务",
              "value": "证券期货监管服务"
            },
            {
              "label": "资本投资服务",
              "value": "资本投资服务"
            },
            {
              "label": "其他资本市场服务",
              "value": "其他资本市场服务"
            }
          ]
        },
        {
          "label": "保险业",
          "value": "保险业",
          "children": [
            {
              "label": "人身保险",
              "value": "人身保险"
            },
            {
              "label": "财产保险",
              "value": "财产保险"
            },
            {
              "label": "再保险",
              "value": "再保险"
            },
            {
              "label": "商业养老金",
              "value": "商业养老金"
            },
            {
              "label": "保险中介服务",
              "value": "保险中介服务"
            },
            {
              "label": "保险资产管理",
              "value": "保险资产管理"
            },
            {
              "label": "保险监管服务",
              "value": "保险监管服务"
            },
            {
              "label": "其他保险活动",
              "value": "其他保险活动"
            }
          ]
        },
        {
          "label": "其他金融业",
          "value": "其他金融业",
          "children": [
            {
              "label": "金融信托与管理服务",
              "value": "金融信托与管理服务"
            },
            {
              "label": "控股公司服务",
              "value": "控股公司服务"
            },
            {
              "label": "非金融机构支付服务",
              "value": "非金融机构支付服务"
            },
            {
              "label": "金融信息服务",
              "value": "金融信息服务"
            },
            {
              "label": "金融资产管理公司",
              "value": "金融资产管理公司"
            },
            {
              "label": "其他未列明金融业",
              "value": "其他未列明金融业"
            }
          ]
        }
      ]
    },
    {
      "label": "房地产业",
      "value": "房地产业",
      "children": [
        {
          "label": "房地产业",
          "value": "房地产业",
          "children": [
            {
              "label": "房地产开发经营",
              "value": "房地产开发经营"
            },
            {
              "label": "物业管理",
              "value": "物业管理"
            },
            {
              "label": "房地产中介服务",
              "value": "房地产中介服务"
            },
            {
              "label": "房地产租赁经营",
              "value": "房地产租赁经营"
            },
            {
              "label": "其他房地产业",
              "value": "其他房地产业"
            }
          ]
        }
      ]
    },
    {
      "label": "租赁和商务服务业",
      "value": "租赁和商务服务业",
      "children": [
        {
          "label": "租赁业",
          "value": "租赁业",
          "children": [
            {
              "label": "机械设备经营租赁",
              "value": "机械设备经营租赁"
            },
            {
              "label": "文体设备和用品出租",
              "value": "文体设备和用品出租"
            },
            {
              "label": "日用品出租",
              "value": "日用品出租"
            }
          ]
        },
        {
          "label": "商务服务业",
          "value": "商务服务业",
          "children": [
            {
              "label": "组织管理服务",
              "value": "组织管理服务"
            },
            {
              "label": "综合管理服务",
              "value": "综合管理服务"
            },
            {
              "label": "法律服务",
              "value": "法律服务"
            },
            {
              "label": "咨询与调查",
              "value": "咨询与调查"
            },
            {
              "label": "广告业",
              "value": "广告业"
            },
            {
              "label": "人力资源服务",
              "value": "人力资源服务"
            },
            {
              "label": "安全保护服务",
              "value": "安全保护服务"
            },
            {
              "label": "会议、展览及相关服务",
              "value": "会议、展览及相关服务"
            },
            {
              "label": "其他商务服务业",
              "value": "其他商务服务业"
            }
          ]
        }
      ]
    },
    {
      "label": "科学研究和技术服务业",
      "value": "科学研究和技术服务业",
      "children": [
        {
          "label": "研究和试验发展",
          "value": "研究和试验发展",
          "children": [
            {
              "label": "自然科学研究和试验发展",
              "value": "自然科学研究和试验发展"
            },
            {
              "label": "工程和技术研究和试验发展",
              "value": "工程和技术研究和试验发展"
            },
            {
              "label": "农业科学研究和试验发展",
              "value": "农业科学研究和试验发展"
            },
            {
              "label": "医学研究和试验发展",
              "value": "医学研究和试验发展"
            },
            {
              "label": "社会人文科学研究",
              "value": "社会人文科学研究"
            }
          ]
        },
        {
          "label": "专业技术服务业",
          "value": "专业技术服务业",
          "children": [
            {
              "label": "气象服务",
              "value": "气象服务"
            },
            {
              "label": "地震服务",
              "value": "地震服务"
            },
            {
              "label": "海洋服务",
              "value": "海洋服务"
            },
            {
              "label": "测绘地理信息服务",
              "value": "测绘地理信息服务"
            },
            {
              "label": "质检技术服务",
              "value": "质检技术服务"
            },
            {
              "label": "环境与生态监测检测服务",
              "value": "环境与生态监测检测服务"
            },
            {
              "label": "地质勘查",
              "value": "地质勘查"
            },
            {
              "label": "工程技术与设计服务",
              "value": "工程技术与设计服务"
            },
            {
              "label": "工业与专业设计及其他专业技术服务",
              "value": "工业与专业设计及其他专业技术服务"
            }
          ]
        },
        {
          "label": "科技推广和应用服务业",
          "value": "科技推广和应用服务业",
          "children": [
            {
              "label": "技术推广服务",
              "value": "技术推广服务"
            },
            {
              "label": "知识产权服务",
              "value": "知识产权服务"
            },
            {
              "label": "科技中介服务",
              "value": "科技中介服务"
            },
            {
              "label": "创业空间服务",
              "value": "创业空间服务"
            },
            {
              "label": "其他科技推广服务业",
              "value": "其他科技推广服务业"
            }
          ]
        }
      ]
    },
    {
      "label": "水利、环境和公共设施管理业",
      "value": "水利、环境和公共设施管理业",
      "children": [
        {
          "label": "水利管理业",
          "value": "水利管理业",
          "children": [
            {
              "label": "防洪除涝设施管理",
              "value": "防洪除涝设施管理"
            },
            {
              "label": "水资源管理",
              "value": "水资源管理"
            },
            {
              "label": "天然水收集与分配",
              "value": "天然水收集与分配"
            },
            {
              "label": "水文服务",
              "value": "水文服务"
            },
            {
              "label": "其他水利管理业",
              "value": "其他水利管理业"
            }
          ]
        },
        {
          "label": "生态保护和环境治理业",
          "value": "生态保护和环境治理业",
          "children": [
            {
              "label": "生态保护",
              "value": "生态保护"
            },
            {
              "label": "环境治理业",
              "value": "环境治理业"
            }
          ]
        },
        {
          "label": "公共设施管理业",
          "value": "公共设施管理业",
          "children": [
            {
              "label": "市政设施管理",
              "value": "市政设施管理"
            },
            {
              "label": "环境卫生管理",
              "value": "环境卫生管理"
            },
            {
              "label": "城乡市容管理",
              "value": "城乡市容管理"
            },
            {
              "label": "绿化管理",
              "value": "绿化管理"
            },
            {
              "label": "城市公园管理",
              "value": "城市公园管理"
            },
            {
              "label": "游览景区管理",
              "value": "游览景区管理"
            }
          ]
        },
        {
          "label": "土地管理业",
          "value": "土地管理业",
          "children": [
            {
              "label": "土地整治服务",
              "value": "土地整治服务"
            },
            {
              "label": "土地调查评估服务",
              "value": "土地调查评估服务"
            },
            {
              "label": "土地登记服务",
              "value": "土地登记服务"
            },
            {
              "label": "土地登记代理服务",
              "value": "土地登记代理服务"
            },
            {
              "label": "其他土地管理服务",
              "value": "其他土地管理服务"
            }
          ]
        }
      ]
    },
    {
      "label": "居民服务、修理和其他服务业",
      "value": "居民服务、修理和其他服务业",
      "children": [
        {
          "label": "居民服务业",
          "value": "居民服务业",
          "children": [
            {
              "label": "家庭服务",
              "value": "家庭服务"
            },
            {
              "label": "托儿所服务",
              "value": "托儿所服务"
            },
            {
              "label": "洗染服务",
              "value": "洗染服务"
            },
            {
              "label": "理发及美容服务",
              "value": "理发及美容服务"
            },
            {
              "label": "洗浴和保健养生服务",
              "value": "洗浴和保健养生服务"
            },
            {
              "label": "摄影扩印服务",
              "value": "摄影扩印服务"
            },
            {
              "label": "婚姻服务",
              "value": "婚姻服务"
            },
            {
              "label": "殡葬服务",
              "value": "殡葬服务"
            },
            {
              "label": "其他居民服务业",
              "value": "其他居民服务业"
            }
          ]
        },
        {
          "label": "机动车、电子产品和日用产品修理业",
          "value": "机动车、电子产品和日用产品修理业",
          "children": [
            {
              "label": "汽车、摩托车等修理与维护",
              "value": "汽车、摩托车等修理与维护"
            },
            {
              "label": "计算机和办公设备维修",
              "value": "计算机和办公设备维修"
            },
            {
              "label": "家用电器修理",
              "value": "家用电器修理"
            },
            {
              "label": "其他日用产品修理业",
              "value": "其他日用产品修理业"
            }
          ]
        },
        {
          "label": "其他服务业",
          "value": "其他服务业",
          "children": [
            {
              "label": "清洁服务",
              "value": "清洁服务"
            },
            {
              "label": "宠物服务",
              "value": "宠物服务"
            },
            {
              "label": "其他未列明服务业",
              "value": "其他未列明服务业"
            }
          ]
        }
      ]
    },
    {
      "label": "教育",
      "value": "教育",
      "children": [
        {
          "label": "教育",
          "value": "教育",
          "children": [
            {
              "label": "学前教育",
              "value": "学前教育"
            },
            {
              "label": "初等教育",
              "value": "初等教育"
            },
            {
              "label": "中等教育",
              "value": "中等教育"
            },
            {
              "label": "高等教育",
              "value": "高等教育"
            },
            {
              "label": "特殊教育",
              "value": "特殊教育"
            },
            {
              "label": "技能培训、教育辅助及其他教育",
              "value": "技能培训、教育辅助及其他教育"
            }
          ]
        }
      ]
    },
    {
      "label": "卫生和社会工作",
      "value": "卫生和社会工作",
      "children": [
        {
          "label": "卫生",
          "value": "卫生",
          "children": [
            {
              "label": "医院",
              "value": "医院"
            },
            {
              "label": "基层医疗卫生服务",
              "value": "基层医疗卫生服务"
            },
            {
              "label": "专业公共卫生服务",
              "value": "专业公共卫生服务"
            },
            {
              "label": "其他卫生活动",
              "value": "其他卫生活动"
            }
          ]
        },
        {
          "label": "社会工作",
          "value": "社会工作",
          "children": [
            {
              "label": "提供住宿社会工作",
              "value": "提供住宿社会工作"
            },
            {
              "label": "不提供住宿社会工作",
              "value": "不提供住宿社会工作"
            }
          ]
        }
      ]
    },
    {
      "label": "文化、体育和娱乐业",
      "value": "文化、体育和娱乐业",
      "children": [
        {
          "label": "新闻和出版业",
          "value": "新闻和出版业",
          "children": [
            {
              "label": "新闻业",
              "value": "新闻业"
            },
            {
              "label": "出版业",
              "value": "出版业"
            }
          ]
        },
        {
          "label": "广播、电视、电影和录音制作业",
          "value": "广播、电视、电影和录音制作业",
          "children": [
            {
              "label": "广播",
              "value": "广播"
            },
            {
              "label": "电视",
              "value": "电视"
            },
            {
              "label": "影视节目制作",
              "value": "影视节目制作"
            },
            {
              "label": "广播电视集成播控",
              "value": "广播电视集成播控"
            },
            {
              "label": "电影和广播电视节目发行",
              "value": "电影和广播电视节目发行"
            },
            {
              "label": "电影放映",
              "value": "电影放映"
            },
            {
              "label": "录音制作",
              "value": "录音制作"
            }
          ]
        },
        {
          "label": "文化艺术业",
          "value": "文化艺术业",
          "children": [
            {
              "label": "文艺创作与表演",
              "value": "文艺创作与表演"
            },
            {
              "label": "艺术表演场馆",
              "value": "艺术表演场馆"
            },
            {
              "label": "图书馆与档案馆",
              "value": "图书馆与档案馆"
            },
            {
              "label": "文物及非物质文化遗产保护",
              "value": "文物及非物质文化遗产保护"
            },
            {
              "label": "博物馆",
              "value": "博物馆"
            },
            {
              "label": "烈士陵园、纪念馆",
              "value": "烈士陵园、纪念馆"
            },
            {
              "label": "群众文体活动",
              "value": "群众文体活动"
            },
            {
              "label": "其他文化艺术业",
              "value": "其他文化艺术业"
            }
          ]
        },
        {
          "label": "体育",
          "value": "体育",
          "children": [
            {
              "label": "体育组织",
              "value": "体育组织"
            },
            {
              "label": "体育场地设施管理",
              "value": "体育场地设施管理"
            },
            {
              "label": "健身休闲活动",
              "value": "健身休闲活动"
            },
            {
              "label": "其他体育",
              "value": "其他体育"
            }
          ]
        },
        {
          "label": "娱乐业",
          "value": "娱乐业",
          "children": [
            {
              "label": "室内娱乐活动",
              "value": "室内娱乐活动"
            },
            {
              "label": "游乐园",
              "value": "游乐园"
            },
            {
              "label": "休闲观光活动",
              "value": "休闲观光活动"
            },
            {
              "label": "彩票活动",
              "value": "彩票活动"
            },
            {
              "label": "文化体育娱乐活动与经纪代理服务",
              "value": "文化体育娱乐活动与经纪代理服务"
            },
            {
              "label": "其他娱乐业",
              "value": "其他娱乐业"
            }
          ]
        }
      ]
    },
    {
      "label": "公共管理、社会保障和社会组织",
      "value": "公共管理、社会保障和社会组织",
      "children": [
        {
          "label": "中国共产党机关",
          "value": "中国共产党机关",
          "children": [
            {
              "label": "中国共产党机关",
              "value": "中国共产党机关"
            }
          ]
        },
        {
          "label": "国家机构",
          "value": "国家机构",
          "children": [
            {
              "label": "国家权力机构",
              "value": "国家权力机构"
            },
            {
              "label": "国家行政机构",
              "value": "国家行政机构"
            },
            {
              "label": "人民法院和人民检察院",
              "value": "人民法院和人民检察院"
            },
            {
              "label": "其他国家机构",
              "value": "其他国家机构"
            }
          ]
        },
        {
          "label": "人民政协、民主党派",
          "value": "人民政协、民主党派",
          "children": [
            {
              "label": "人民政协",
              "value": "人民政协"
            },
            {
              "label": "民主党派",
              "value": "民主党派"
            }
          ]
        },
        {
          "label": "社会保障",
          "value": "社会保障",
          "children": [
            {
              "label": "基本保险",
              "value": "基本保险"
            },
            {
              "label": "补充保险",
              "value": "补充保险"
            },
            {
              "label": "其他社会保障",
              "value": "其他社会保障"
            }
          ]
        },
        {
          "label": "群众团体、社会团体和其他成员组织",
          "value": "群众团体、社会团体和其他成员组织",
          "children": [
            {
              "label": "群众团体",
              "value": "群众团体"
            },
            {
              "label": "社会团体",
              "value": "社会团体"
            },
            {
              "label": "基金会",
              "value": "基金会"
            },
            {
              "label": "宗教组织",
              "value": "宗教组织"
            }
          ]
        },
        {
          "label": "基层群众自治组织及其他组织",
          "value": "基层群众自治组织及其他组织",
          "children": [
            {
              "label": "社区居民自治组织",
              "value": "社区居民自治组织"
            },
            {
              "label": "村民自治组织",
              "value": "村民自治组织"
            }
          ]
        }
      ]
    },
    {
      "label": "国际组织",
      "value": "国际组织",
      "children": [
        {
          "label": "国际组织",
          "value": "国际组织",
          "children": [
            {
              "label": "国际组织",
              "value": "国际组织"
            }
          ]
        }
      ]
    }
  ];

export default industryData;